import API from "../../api/api";
import { Link } from "react-router-dom";
import React, { Component } from "react";
import { Header, Footer } from "../../components";
import "../../styles/css/BrowseGuest/BrowseGuest.css";
import { Container, Row, Col } from "bootstrap-4-react";
import HeaderCard from "../../components/ProjectCards/HeaderCard";
import DetailCard from "../../components/ProjectCards/DetailCard";
import ProjectCard from "../../components/ProjectCards/ProjectCard";

class BrowseGuest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jobData: [],
      cardData: [],

      // searchParams
      searchKey: "",
      surveyType: "",
    };
  }

  async searchJobs(key, type) {
    await this.setState({
      searchKey: key,
      surveyType: type,
    });
    await this.getJobs();
  }

  getJobs() {
    API.get(
      `dashboard/guest?job_name=${this.state.searchKey}&survey_type=${this.state.surveyType}`
    )
      .then((res) => {
        console.log("adssdss", res);
        this.setState({
          jobData: res.data.response.jobs,
          cardData: res.data.response.card,
        });
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  }

  componentDidMount() {
    this.getJobs();
  }

  render() {
    const { jobData, cardData } = this.state;

    console.log("str", this.props.match.params.str);

    return (
      <div>
        <Header />
        <Container className="breadCrubmContainerDashboard">
          <div className="breadCrumb">
            <Link to="/landing" className="prevLinks">
              Home
            </Link>
            <span>&nbsp;&gt;&nbsp;</span>
            <span className="currLink">Browse jobs</span>
          </div>
        </Container>
        <div className="browseMain">
          <Container>
            <Row>
              <Col col="sm-12 md-12 lg-12">
                <div>
                  <HeaderCard searchJobs={this.searchJobs.bind(this)} />
                </div>
              </Col>
            </Row>
            <Row>
              {/* <Col col="sm-12 md-12 lg-3">
                <div>
                  <DetailCard details={cardData} />
                </div>
              </Col> */}
              <Col col="sm-12 md-12 lg-12">
                {jobData &&
                  jobData.map((job) => {
                    return (
                      <ProjectCard
                        key={job.id}
                        jobData={job}
                        str={this.props.match.params.str}
                      />
                    );
                  })}
              </Col>
            </Row>
          </Container>
        </div>
        <Footer />
      </div>
    );
  }
}

export default BrowseGuest;



// WEBPACK FOOTER //
// ./src/pages/BrowseGuest/BrowseGuest.js